import { fields } from "@monorepo/utils/src/variables/projectsData/passportArchiveReport/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.FILTER_ARCHIVE]: {},
  [fields.FILTER_START_YEAR]: null,
  [fields.FILTER_END_YEAR]: null,
});
